import { ext } from 'vee-validate/dist/rules';

const handler = {
  validate: (field, options) => ext.validate(field, options.values),
  params: ['values']
};

export { handler as ext };
